import { render, staticRenderFns } from "./ratingTask.vue?vue&type=template&id=3b800a18&scoped=true"
import script from "./ratingTask.vue?vue&type=script&lang=js"
export * from "./ratingTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b800a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b800a18')) {
      api.createRecord('3b800a18', component.options)
    } else {
      api.reload('3b800a18', component.options)
    }
    module.hot.accept("./ratingTask.vue?vue&type=template&id=3b800a18&scoped=true", function () {
      api.rerender('3b800a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/AAA/ratingTask.vue"
export default component.exports